import { graphql } from "@/lib/gql/__generated__";

export const TICKET_PRO_PURCHASE_MUTATION = graphql(/* GraphQL */ `
	mutation TicketProPurchase($input: ProTicketPurchaseInput!) {
		ticketProPurchase(input: $input) {
			userErrors
			billingStatus {
				id
				hotelID
				defaultBasicBillingTicketID
				defaultBasicBillingTicketName
				isStopRecurringBasicBilling
				currentBasicBillingTicketName
				validDtEndBasic
				nextBillingDtBasic
				defaultProBillingTicketID
				defaultProBillingTicketName
				isStopRecurringProBilling
				currentProBillingTicketName
				validDtEndPro
				nextBillingDtPro
			}
		}
	}
`);
